
{
  "familyId": "REK-GEMENGD-TOETS",
  "questions": [
    {
      "id": "REK-GEMENGD-TOETS-001",
      "familyId": "REK-GEMENGD-TOETS",
      "module": "Basisrekenen",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "gemengd",
      "subSkill": "gemengd_toets",
      "questionType": "multiple_choice",
      "question": "Reken uit: 5 + 3 × (12 − 4)",
      "options": ["29", "64", "32", "24"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meneer Van Dansen Wacht Op Antwoord",
            "content": "Volgorde: 1) Haakjes, 2) Machten, 3) Vermenigvuldigen/Delen, 4) Optellen/Aftrekken. Eerst haakjes: 12 − 4 = 8. Dan ×: 3 × 8 = 24. Dan +: 5 + 24 = 29.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_toets_volgorde",
      "variantIndex": 1,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Volgorde bewerkingen: eerst haakjes (12 − 4 = 8), dan vermenigvuldigen (3 × 8 = 24), dan optellen (5 + 24 = 29). Onthoud: Meneer Van Dansen Wacht Op Antwoord (Machten, Vermenigvuldigen/Delen, Wortels, Optellen/Aftrekken).",
        "solutionSteps": [
          "Haakjes: 12 − 4 = 8",
          "Vermenigvuldigen: 3 × 8 = 24",
          "Optellen: 5 + 24 = 29"
        ],
        "distractorExplanations": {
          "0": "Goed! Haakjes eerst, dan ×, dan +. 5 + 3 × 8 = 5 + 24 = 29.",
          "1": "Je rekende van links naar rechts: (5 + 3) × (12 − 4) = 8 × 8 = 64. Maar 5 + 3 staat niet tussen haakjes! Alleen (12 − 4) is een haakje. Eerst: 3 × 8 = 24, dan 5 + 24 = 29.",
          "2": "Je dacht waarschijnlijk (5 + 3) × 4 = 32. Maar de volgorde is: haakjes (12−4=8), dan × (3×8=24), dan + (5+24=29).",
          "3": "Je berekende alleen 3 × (12 − 4) = 3 × 8 = 24, maar vergat de 5 erbij op te tellen. 5 + 24 = 29."
        }
      }
    },
    {
      "id": "REK-GEMENGD-TOETS-002",
      "familyId": "REK-GEMENGD-TOETS",
      "module": "Basisrekenen",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "gemengd",
      "subSkill": "gemengd_toets",
      "questionType": "fill_in",
      "question": "Reken handig uit: 25 × 36",
      "options": [],
      "correctAnswer": "900",
      "data": {
        "acceptedAnswers": ["900"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Factoren herkennen",
            "content": "25 × 36: splits 36 in 4 × 9. Nu: 25 × 4 = 100, dan 100 × 9 = 900. Of: 25 × 36 = 25 × 4 × 9 = 100 × 9 = 900. Gebruik het standaardproduct 25 × 4 = 100!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_toets_handig_keer",
      "variantIndex": 2,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "25 × 36 = 900. Handig: splits 36 in factoren: 36 = 4 × 9. Nu: 25 × 4 = 100 (standaardproduct!), dan 100 × 9 = 900. Dit is de kern van handig vermenigvuldigen: zoek naar combinaties die ronde getallen opleveren.",
        "solutionSteps": [
          "Herken: 36 = 4 × 9",
          "25 × 4 = 100 (standaardproduct)",
          "100 × 9 = 900"
        ]
      }
    },
    {
      "id": "REK-GEMENGD-TOETS-003",
      "familyId": "REK-GEMENGD-TOETS",
      "module": "Basisrekenen",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "gemengd",
      "subSkill": "gemengd_toets",
      "questionType": "multiple_choice",
      "question": "Een elektricien werkt 5 dagen. De eerste 3 dagen werkt ze 8 uur per dag voor €32 per uur. De laatste 2 dagen werkt ze 6 uur per dag voor €38 per uur (weekend-tarief). Hoeveel verdient ze in totaal?",
      "options": ["€1.224", "€1.120", "€1.280", "€1.024"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Splits in twee periodes",
            "content": "Periode 1: 3 dagen × 8 uur × €32 = 24 × €32 = €768. Periode 2: 2 dagen × 6 uur × €38 = 12 × €38 = €456. Totaal: €768 + €456 = €1.224. Tip: reken elke periode apart uit.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_toets_context_meerstaps",
      "variantIndex": 3,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Periode 1: 3 × 8 = 24 uur × €32 = €768. Periode 2: 2 × 6 = 12 uur × €38 = €456. Totaal: €768 + €456 = €1.224. Bij meerstaps-opgaven met verschillende tarieven: splits in periodes en reken elke periode apart uit.",
        "solutionSteps": [
          "Periode 1: 3 × 8 = 24 uur",
          "24 × €32 = €768",
          "Periode 2: 2 × 6 = 12 uur",
          "12 × €38 = €456",
          "Totaal: €768 + €456 = €1.224"
        ],
        "distractorExplanations": {
          "0": "Goed! €768 + €456 = €1.224 in totaal.",
          "1": "Je dacht waarschijnlijk 5 × 8 × €32 = €1.280, maar de laatste 2 dagen werkt ze maar 6 uur (niet 8) en voor €38 (niet €32). Reken elke periode apart.",
          "2": "Je dacht waarschijnlijk 5 × 8 × €32 = €1.280. Maar de laatste 2 dagen zijn anders: 6 uur voor €38. Reken apart: €768 + €456 = €1.224.",
          "3": "Je dacht waarschijnlijk 3 × 8 × €32 = €768, plus 2 × 6 × €32 = €384. Maar het weekend-tarief is €38, niet €32. 12 × €38 = €456. Totaal: €1.224."
        }
      }
    },
    {
      "id": "REK-GEMENGD-TOETS-004",
      "familyId": "REK-GEMENGD-TOETS",
      "module": "Basisrekenen",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "gemengd",
      "subSkill": "gemengd_toets",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 1.600 ÷ 32",
      "options": ["50", "48", "52", "55"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Herhaald halveren",
            "content": "32 = 2⁵, dus halveer 5 keer: 1.600 → 800 → 400 → 200 → 100 → 50. Of via factoren: 32 = 4 × 8. 1.600 ÷ 4 = 400, dan 400 ÷ 8 = 50.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_toets_handig_deel",
      "variantIndex": 4,
      "citoDifficulty": 0.56,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "1.600 ÷ 32 = 50. Handig: 32 = 2⁵, dus halveer 5 keer: 1.600 → 800 → 400 → 200 → 100 → 50. Of via factoren: 1.600 ÷ 4 = 400, dan 400 ÷ 8 = 50.",
        "solutionSteps": [
          "Herken: 32 = 2 × 2 × 2 × 2 × 2",
          "1.600 ÷ 2 = 800 ÷ 2 = 400 ÷ 2 = 200 ÷ 2 = 100 ÷ 2 = 50",
          "Antwoord: 50"
        ],
        "distractorExplanations": {
          "0": "Goed! 1.600 ÷ 32 = 50. Vijf keer halveren!",
          "1": "Je dacht waarschijnlijk 1.600 ÷ 32 ≈ 48. Maar 48 × 32 = 1.536 ≠ 1.600. Controleer: 50 × 32 = 1.600. ✓",
          "2": "Je dacht waarschijnlijk 1.600 ÷ 32 ≈ 52. Maar 52 × 32 = 1.664 ≠ 1.600. Controleer: 50 × 32 = 1.600. ✓",
          "3": "Je dacht waarschijnlijk 1.600 ÷ 32 ≈ 55. Maar 55 × 32 = 1.760 ≠ 1.600. Controleer: 50 × 32 = 1.600. ✓"
        }
      }
    },
    {
      "id": "REK-GEMENGD-TOETS-005",
      "familyId": "REK-GEMENGD-TOETS",
      "module": "Basisrekenen",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "gemengd",
      "subSkill": "gemengd_toets",
      "questionType": "multiple_choice",
      "question": "Schat het antwoord: 489 × 21. Welke schatting komt het dichtst bij het exacte antwoord?",
      "options": ["Ongeveer 10.000", "Ongeveer 9.000", "Ongeveer 11.000", "Ongeveer 8.000"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schatten: rond af naar handige getallen",
            "content": "489 ≈ 500, 21 ≈ 20. Schatting: 500 × 20 = 10.000. Exact: 489 × 21 = 10.269. De schatting van 10.000 zit er maar 269 naast! Tip: rond af naar getallen die makkelijk te vermenigvuldigen zijn.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_toets_schatten",
      "variantIndex": 5,
      "citoDifficulty": 0.54,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "489 ≈ 500, 21 ≈ 20. Schatting: 500 × 20 = 10.000. Het exacte antwoord is 489 × 21 = 10.269 — de schatting zit er maar 2,6% naast. Bij schatten rond je af naar handige getallen die makkelijk te vermenigvuldigen zijn.",
        "solutionSteps": [
          "Afronden: 489 ≈ 500, 21 ≈ 20",
          "Schatting: 500 × 20 = 10.000",
          "Exact: 489 × 21 = 10.269 (dicht bij 10.000)"
        ],
        "distractorExplanations": {
          "0": "Goed! 500 × 20 = 10.000 is de beste schatting. Exact: 10.269.",
          "1": "Je dacht waarschijnlijk 450 × 20 = 9.000. Maar 489 is dichter bij 500 dan bij 450. 500 × 20 = 10.000 is nauwkeuriger.",
          "2": "Je dacht waarschijnlijk 500 × 22 = 11.000. Maar 21 is dichter bij 20 dan bij 22. 500 × 20 = 10.000 is nauwkeuriger.",
          "3": "Je dacht waarschijnlijk 400 × 20 = 8.000. Maar 489 is veel dichter bij 500 dan bij 400. 500 × 20 = 10.000 is nauwkeuriger."
        }
      }
    }
  ]
}
